export const topBannerScoller = (): void => {
  const topBannerWrapper = document.querySelector('.js-topBanner') as unknown as HTMLElement

  const bodyElement = document.querySelector('body') as unknown as HTMLElement

  if (!topBannerWrapper || !bodyElement) {
    return
  }

  const allScrollLinks = topBannerWrapper.querySelectorAll('.js-topBanner-bottomTrigger') as unknown as HTMLElement[]

  allScrollLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault()

      const offset = topBannerWrapper.offsetHeight

      window.scroll({
        top: offset,
        behavior: 'smooth'
      })
    })
  })
}
